<template>
    <div class="plot-reference-assigner-component">
        <h4>Plot Reference</h4>
        <h5 v-if="currentReference">Code: <code>{{ currentReference }}</code></h5>

        <button
            v-if="!show"
            type="button"
            class="btn btn-primary btn-sm"
            @click="show = !show"
        >
            Assign a new plot via reference
        </button>
        <div v-else class="mt-4">
            <div class="row">
                <div class="col-12 col-md-4">
                    <div class="form-group">
                        <label for="plot_ref_search">Search</label>
                        <input
                            type="text"
                            class="form-control"
                            id="plot_ref_search"
                            v-model="search"
                            @input="searchPlots"
                            placeholder="Search for a plot by reference"
                        />
                    </div>

                    <div v-if="loading" class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>

                    <ul v-if="plots.length > 0" class="list-group">
                        <li
                            class="list-group-item cursor-pointer"
                            v-for="plot in plots"
                            :key="plot.id"
                            @click="assignPlot(plot)"
                        >
                            {{ plot.reference }}
                            <span v-if="availablePlotStatuses.includes(plot.plot_status_id)" class="ms-3 text-success">Available</span>
                            <span v-else class="ms-3 text-danger">Not Available</span>
                        </li>
                    </ul>

                    <small v-if="plots.length > 0" class="text-muted">Click a plot reference above to assign it to the customer.</small>

                    <small v-if="!loading && search !== null && search.trim() !== '' && plots.length === 0" class="text-muted">No plots were found.</small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            search: null,
            plots: [],
            loading: false,
            currentReference: null,
            availablePlotStatuses: [2, 5],
        };
    },

    props: {
        reference: {
            type: String,
            required: false,
            default: null,
        },
    },

    created() {
        this.currentReference = this.reference;
    },

    methods: {
        searchPlots() {
            this.plots = [];
            this.loading = true;

            axios
                .post("/api/v1/admin/users/search-plots-by-ref", {
                    reference: this.search
                })
                .then(response => {
                    this.plots = response.data.plots;
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    console.log(error);
                });
        },

        assignPlot(plot) {
            if (!this.availablePlotStatuses.includes(plot.plot_status_id)) {
                return notyf.error("This plot is not available for assignment.");
            }

            $("#development_id").val(null);

            // This is nested because the form uses some jQuery to filter
            // the options based on the selected values.
            this.$nextTick(() => {
                $("#development_id").val(plot.development_id);

                this.$nextTick(() => {
                    $("#house_type_id").val(plot.house_type_id);

                    this.$nextTick(() => {
                        $("#plot_id").val(plot.id);
                    });
                });
            });

            this.plots = [];
            this.search = null;
            this.show = false;
            this.currentReference = plot.reference;
        }
    }
};
</script>
